export default {"src":"/_next/static/media/package-icon.7a7647cb.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};